/* tslint:disable */
/* eslint-disable */
/* @relayHash 78c1b0b28634dddd4b24d26f15301df7 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type UnansweredCommentsTabContainerPaginationQueryVariables = {
    count: number;
    cursor?: unknown | null;
    orderBy: COMMENT_SORT;
    storyID?: string | null;
    flattenReplies: boolean;
};
export type UnansweredCommentsTabContainerPaginationQueryResponse = {
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabContainer_story">;
    } | null;
};
export type UnansweredCommentsTabContainerPaginationQuery = {
    readonly response: UnansweredCommentsTabContainerPaginationQueryResponse;
    readonly variables: UnansweredCommentsTabContainerPaginationQueryVariables;
};



/*
query UnansweredCommentsTabContainerPaginationQuery(
  $count: Int!
  $cursor: Cursor
  $orderBy: COMMENT_SORT!
  $storyID: ID
  $flattenReplies: Boolean!
) {
  story(id: $storyID) {
    ...UnansweredCommentsTabContainer_story_32czeo
    id
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CaretContainer_story on Story {
  ...ModerationDropdownContainer_story
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
  }
  parent {
    author {
      username
      id
    }
    id
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...RejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
}

fragment CommentContainer_story on Story {
  id
  url
  isClosed
  canModerate
  settings {
    mode
  }
  ...CaretContainer_story
  ...EditCommentFormContainer_story
  ...PermalinkButtonContainer_story
  ...ReplyCommentFormContainer_story
  ...UserTagsContainer_story
}

fragment CreateCommentMutation_story on Story {
  id
  viewerRating {
    id
    tags {
      code
    }
    rating
  }
  settings {
    moderation
    mode
    live {
      enabled
    }
  }
  ratings {
    count
    average
  }
}

fragment CreateCommentReplyMutation_story on Story {
  settings {
    moderation
  }
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment EditCommentFormContainer_story on Story {
  id
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  author {
    id
    username
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment LocalReplyListContainer_story on Story {
  ...CommentContainer_story
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment MessageBoxContainer_story on Story {
  settings {
    messageBox {
      content
      icon
    }
    mode
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  revision {
    id
  }
  status
  tags {
    code
  }
}

fragment ModerationActionsContainer_story on Story {
  id
  settings {
    mode
  }
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationDropdownContainer_story on Story {
  id
  ...ModerationActionsContainer_story
  ...UserBanPopoverContainer_story
}

fragment PermalinkButtonContainer_story on Story {
  url
}

fragment PostCommentFormContainer_story on Story {
  id
  isClosed
  site {
    id
  }
  viewerRating {
    id
    status
    tags {
      code
    }
    rating
  }
  settings {
    messageBox {
      enabled
    }
    experts {
      id
    }
    mode
  }
  ...MessageBoxContainer_story
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment RejectedTombstoneContainer_comment on Comment {
  id
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
}

fragment ReplyCommentFormContainer_story on Story {
  id
  isClosed
}

fragment ReplyListContainer1_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer2_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer1_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...CommentContainer_story
  ...ReplyListContainer2_story
}

fragment ReplyListContainer2_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer3_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer2_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...CommentContainer_story
  ...ReplyListContainer3_story
}

fragment ReplyListContainer3_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainerLast_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...CommentContainer_story
  ...ReplyListContainerLast_story
}

fragment ReplyListContainerLastFlattened_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC, flatten: $flattenReplies) {
    edges {
      node {
        id
        replyCount
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        __typename
      }
      __typename
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLastFlattened_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...CommentContainer_story
}

fragment ReplyListContainerLast_comment on Comment {
  ...LocalReplyListContainer_comment @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_comment @include(if: $flattenReplies)
}

fragment ReplyListContainerLast_story on Story {
  ...LocalReplyListContainer_story @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_story @include(if: $flattenReplies)
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment UnansweredCommentsTabContainer_story_32czeo on Story {
  id
  isClosed
  settings {
    live {
      enabled
    }
  }
  commentCounts {
    tags {
      UNANSWERED
    }
  }
  comments(first: $count, after: $cursor, orderBy: $orderBy, tag: UNANSWERED) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...ReplyListContainer1_comment
        ...IgnoredTombstoneOrHideContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...PostCommentFormContainer_story
  ...CommentContainer_story
  ...ReplyListContainer1_story
  ...CreateCommentReplyMutation_story
  ...CreateCommentMutation_story
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserBanPopoverContainer_story on Story {
  id
  site {
    id
    name
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "flattenReplies"
    } as any), v3 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    } as any), v4 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v5 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any)
    ], v6 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy"
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v9 = [
        (v7 /*: any*/)
    ], v10 = [
        ({
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        } as any),
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        } as any),
        (v6 /*: any*/),
        ({
            "kind": "Literal",
            "name": "tag",
            "value": "UNANSWERED"
        } as any)
    ], v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v7 /*: any*/),
            (v11 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badges",
                "storageKey": null
            },
            (v12 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v11 /*: any*/),
                    (v7 /*: any*/)
                ],
                "storageKey": null
            },
            (v7 /*: any*/)
        ],
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v7 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v23 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v24 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v24 /*: any*/),
                            (v25 /*: any*/)
                        ],
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v26 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v24 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": (v9 /*: any*/),
        "storageKey": null
    } as any), v29 = ({
        "kind": "Literal",
        "name": "first",
        "value": 10
    } as any), v30 = ({
        "kind": "Literal",
        "name": "orderBy",
        "value": "CREATED_AT_ASC"
    } as any), v31 = [
        (v29 /*: any*/),
        (v30 /*: any*/)
    ], v32 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v33 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v34 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v35 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v36 = ({
        "kind": "ClientExtension",
        "selections": [
            (v33 /*: any*/),
            (v34 /*: any*/),
            (v35 /*: any*/)
        ]
    } as any), v37 = [
        ({
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "localReplies",
            "plural": true,
            "selections": [
                (v7 /*: any*/),
                (v13 /*: any*/),
                (v14 /*: any*/),
                (v15 /*: any*/),
                (v12 /*: any*/),
                (v16 /*: any*/),
                (v17 /*: any*/),
                (v18 /*: any*/),
                (v19 /*: any*/),
                (v33 /*: any*/),
                (v34 /*: any*/),
                (v20 /*: any*/),
                (v21 /*: any*/),
                (v22 /*: any*/),
                (v27 /*: any*/),
                (v28 /*: any*/)
            ],
            "storageKey": null
        } as any)
    ], v38 = [
        (v29 /*: any*/),
        ({
            "kind": "Variable",
            "name": "flatten",
            "variableName": "flattenReplies"
        } as any),
        (v30 /*: any*/)
    ], v39 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v40 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v41 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v39 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v7 /*: any*/),
                    (v35 /*: any*/),
                    (v32 /*: any*/),
                    (v13 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v12 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v27 /*: any*/),
                    (v28 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v42 = [
        "orderBy"
    ], v43 = ({
        "alias": null,
        "args": (v38 /*: any*/),
        "filters": (v42 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v44 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": false,
        "selections": (v37 /*: any*/)
    } as any), v45 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": null,
                "args": (v38 /*: any*/),
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "replies",
                "plural": false,
                "selections": [
                    (v41 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v7 /*: any*/),
                                    (v35 /*: any*/),
                                    (v32 /*: any*/),
                                    (v13 /*: any*/),
                                    (v14 /*: any*/),
                                    (v15 /*: any*/),
                                    (v12 /*: any*/),
                                    (v16 /*: any*/),
                                    (v17 /*: any*/),
                                    (v18 /*: any*/),
                                    (v19 /*: any*/),
                                    (v33 /*: any*/),
                                    (v34 /*: any*/),
                                    (v20 /*: any*/),
                                    (v21 /*: any*/),
                                    (v22 /*: any*/),
                                    (v27 /*: any*/),
                                    (v28 /*: any*/),
                                    (v23 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v23 /*: any*/),
                            (v39 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v40 /*: any*/)
                ],
                "storageKey": null
            },
            (v43 /*: any*/)
        ]
    } as any), v46 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v39 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v7 /*: any*/),
                    (v35 /*: any*/),
                    (v32 /*: any*/),
                    (v13 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v12 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v27 /*: any*/),
                    (v28 /*: any*/),
                    (v44 /*: any*/),
                    (v45 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v47 = ({
        "alias": null,
        "args": (v31 /*: any*/),
        "filters": (v42 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v48 = ({
        "alias": null,
        "args": (v31 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v46 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v7 /*: any*/),
                            (v35 /*: any*/),
                            (v32 /*: any*/),
                            (v13 /*: any*/),
                            (v14 /*: any*/),
                            (v15 /*: any*/),
                            (v12 /*: any*/),
                            (v16 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v27 /*: any*/),
                            (v28 /*: any*/),
                            (v23 /*: any*/),
                            (v44 /*: any*/),
                            (v45 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v39 /*: any*/)
                ],
                "storageKey": null
            },
            (v40 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v49 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v39 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v7 /*: any*/),
                    (v35 /*: any*/),
                    (v32 /*: any*/),
                    (v13 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v12 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v27 /*: any*/),
                    (v28 /*: any*/),
                    (v48 /*: any*/),
                    (v47 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v50 = ({
        "alias": null,
        "args": (v31 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v49 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v7 /*: any*/),
                            (v35 /*: any*/),
                            (v32 /*: any*/),
                            (v13 /*: any*/),
                            (v14 /*: any*/),
                            (v15 /*: any*/),
                            (v12 /*: any*/),
                            (v16 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v27 /*: any*/),
                            (v28 /*: any*/),
                            (v48 /*: any*/),
                            (v47 /*: any*/),
                            (v23 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v39 /*: any*/)
                ],
                "storageKey": null
            },
            (v40 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v51 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v39 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v7 /*: any*/),
                    (v35 /*: any*/),
                    (v32 /*: any*/),
                    (v13 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v12 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v27 /*: any*/),
                    (v28 /*: any*/),
                    (v50 /*: any*/),
                    (v47 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "UnansweredCommentsTabContainerPaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v5 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                (v6 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "UnansweredCommentsTabContainer_story"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "UnansweredCommentsTabContainerPaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v5 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LiveConfiguration",
                                    "kind": "LinkedField",
                                    "name": "live",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoryMessageBox",
                                    "kind": "LinkedField",
                                    "name": "messageBox",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "content",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "icon",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "experts",
                                    "plural": true,
                                    "selections": (v9 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderation",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentCounts",
                            "kind": "LinkedField",
                            "name": "commentCounts",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentTagCounts",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "UNANSWERED",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v10 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v7 /*: any*/),
                                                (v13 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v12 /*: any*/),
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/),
                                                (v20 /*: any*/),
                                                (v21 /*: any*/),
                                                (v22 /*: any*/),
                                                (v27 /*: any*/),
                                                (v28 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v31 /*: any*/),
                                                    "concreteType": "CommentsConnection",
                                                    "kind": "LinkedField",
                                                    "name": "replies",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v19 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        (v22 /*: any*/),
                                                                        (v27 /*: any*/),
                                                                        (v28 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v31 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "replies",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v7 /*: any*/),
                                                                                                (v32 /*: any*/),
                                                                                                (v13 /*: any*/),
                                                                                                (v14 /*: any*/),
                                                                                                (v15 /*: any*/),
                                                                                                (v12 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                (v18 /*: any*/),
                                                                                                (v19 /*: any*/),
                                                                                                (v20 /*: any*/),
                                                                                                (v21 /*: any*/),
                                                                                                (v22 /*: any*/),
                                                                                                (v27 /*: any*/),
                                                                                                (v28 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": (v31 /*: any*/),
                                                                                                    "concreteType": "CommentsConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "replies",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CommentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Comment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v7 /*: any*/),
                                                                                                                        (v32 /*: any*/),
                                                                                                                        (v13 /*: any*/),
                                                                                                                        (v14 /*: any*/),
                                                                                                                        (v15 /*: any*/),
                                                                                                                        (v12 /*: any*/),
                                                                                                                        (v16 /*: any*/),
                                                                                                                        (v17 /*: any*/),
                                                                                                                        (v18 /*: any*/),
                                                                                                                        (v19 /*: any*/),
                                                                                                                        (v20 /*: any*/),
                                                                                                                        (v21 /*: any*/),
                                                                                                                        (v22 /*: any*/),
                                                                                                                        (v27 /*: any*/),
                                                                                                                        (v28 /*: any*/),
                                                                                                                        (v23 /*: any*/),
                                                                                                                        (v36 /*: any*/),
                                                                                                                        {
                                                                                                                            "condition": "flattenReplies",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                    "selections": (v37 /*: any*/)
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "flattenReplies",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": (v38 /*: any*/),
                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "replies",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": null,
                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "alias": null,
                                                                                                                                                    "args": null,
                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        (v7 /*: any*/),
                                                                                                                                                        (v32 /*: any*/),
                                                                                                                                                        (v13 /*: any*/),
                                                                                                                                                        (v14 /*: any*/),
                                                                                                                                                        (v15 /*: any*/),
                                                                                                                                                        (v12 /*: any*/),
                                                                                                                                                        (v16 /*: any*/),
                                                                                                                                                        (v17 /*: any*/),
                                                                                                                                                        (v18 /*: any*/),
                                                                                                                                                        (v19 /*: any*/),
                                                                                                                                                        (v20 /*: any*/),
                                                                                                                                                        (v21 /*: any*/),
                                                                                                                                                        (v22 /*: any*/),
                                                                                                                                                        (v27 /*: any*/),
                                                                                                                                                        (v28 /*: any*/),
                                                                                                                                                        (v23 /*: any*/),
                                                                                                                                                        (v36 /*: any*/)
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": null
                                                                                                                                                },
                                                                                                                                                (v23 /*: any*/),
                                                                                                                                                (v39 /*: any*/)
                                                                                                                                            ],
                                                                                                                                            "storageKey": null
                                                                                                                                        },
                                                                                                                                        (v40 /*: any*/),
                                                                                                                                        {
                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                            "selections": [
                                                                                                                                                (v41 /*: any*/)
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                },
                                                                                                                                (v43 /*: any*/)
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v39 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v40 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                (v46 /*: any*/)
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                                                },
                                                                                                (v47 /*: any*/),
                                                                                                (v23 /*: any*/),
                                                                                                (v36 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v39 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v40 /*: any*/),
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        (v49 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                        },
                                                                        (v47 /*: any*/),
                                                                        (v23 /*: any*/),
                                                                        (v36 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v39 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v40 /*: any*/),
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                (v51 /*: any*/)
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                },
                                                (v47 /*: any*/),
                                                (v23 /*: any*/),
                                                (v36 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v39 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v40 /*: any*/),
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "viewNewEdges",
                                            "plural": true,
                                            "selections": [
                                                (v39 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v35 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v28 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v31 /*: any*/),
                                                            "concreteType": "CommentsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "replies",
                                                            "plural": false,
                                                            "selections": [
                                                                (v51 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                (v35 /*: any*/),
                                                                                (v32 /*: any*/),
                                                                                (v13 /*: any*/),
                                                                                (v14 /*: any*/),
                                                                                (v15 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v16 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v18 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v33 /*: any*/),
                                                                                (v34 /*: any*/),
                                                                                (v20 /*: any*/),
                                                                                (v21 /*: any*/),
                                                                                (v22 /*: any*/),
                                                                                (v27 /*: any*/),
                                                                                (v28 /*: any*/),
                                                                                (v50 /*: any*/),
                                                                                (v47 /*: any*/),
                                                                                (v23 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v39 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v40 /*: any*/)
                                                            ],
                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                        },
                                                        (v47 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v10 /*: any*/),
                            "filters": [
                                "orderBy",
                                "tag"
                            ],
                            "handle": "connection",
                            "key": "UnansweredStream_comments",
                            "kind": "LinkedHandle",
                            "name": "comments"
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "site",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "viewerRating",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                (v16 /*: any*/),
                                (v19 /*: any*/),
                                (v17 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v24 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canModerate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "closedAt",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryRatings",
                            "kind": "LinkedField",
                            "name": "ratings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "count",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "average",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "78c1b0b28634dddd4b24d26f15301df7",
            "metadata": {},
            "name": "UnansweredCommentsTabContainerPaginationQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '3782a828758948a7f994b0bd5b35f45b';
export default node;
